import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AnnouncementBar, Features, Hero, Values } from '@/components/home/Intro';
import { Plans, TellySection } from '@/components/home/Plans';
import { Products } from '@/components/home/Products';
import { Devices, FAQ, Reviews } from '@/components/home/Social';
import { Contact, Portals } from '@/components/home/Contact';
import { StatusStrip } from '@/components/home/StatusStrip';
import { DEFAULT_DESCRIPTION, useSeo } from '@/shared/seo';

export const route = { path: '/', layout: 'public', access: 'public' };

function useScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return undefined;
    const t = setTimeout(() => {
      const el = document.getElementById(location.hash.slice(1));
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
    return () => clearTimeout(t);
  }, [location.hash, location.key]);
}

export default function Home() {
  useScrollToHash();
  useSeo({ path: '/', description: DEFAULT_DESCRIPTION });

  return (
    <div className="overflow-x-hidden pb-24">
      <AnnouncementBar />
      <StatusStrip />
      <Hero />
      <Values />
      <Features />
      <Plans />
      <TellySection />
      <Products />
      <Devices />
      <Reviews />
      <FAQ />
      <Contact />
      <Portals />
    </div>
  );
}
